module.exports = __webpack_public_path__ + "img/tupian.9d10d44b.png";